import { render, staticRenderFns } from "./CommonLeadingIn.vue?vue&type=template&id=64b7ea3c&"
import script from "./CommonLeadingIn.vue?vue&type=script&lang=js&"
export * from "./CommonLeadingIn.vue?vue&type=script&lang=js&"
import style0 from "./CommonLeadingIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports